import { axios } from '@/utils/request';
import { replaceImage } from "@/utils/util";
// sip
export function sipLogin(data) {
  return axios({ url: 'sip/login/account', method: 'post', data: data });
}
export function sipLogout() {
  return axios({ url: '/sip/logout', method: 'post' });
}
// sip user
export function sipUser() {
  return axios({ url: '/sip/user', method: 'get' });
}
export function sipUserByUid(uid) {
  return axios({ url: '/sip/user/' + uid, method: 'get' });
}
export function sipUserList(params) {
  return axios({ url: '/sip/user/list', method: 'get', params: params });
}
export function sipUpdate(data) {
  return axios({ url: '/sip/update', method: 'post', data: data });
}
export function sipRoleUpdateUser(data) {
  return axios({ url: '/sip/role/update/user', method: 'post', data: data });
}
export function sipUpdatePassword(data) {
  return axios({ url: '/sip/update/password', method: 'post', data: data });
}
export function sipUpdateMobile(data) {
  return axios({ url: '/sip/update/mobile', method: 'post', data: data });
}
// 1 手机号需要不存在  2  手机号需要存在
export function sipSms(mobile, type) {
  return axios({
    url: '/sip/sms',
    method: 'post',
    data: { mobile: mobile, type: type }
  });
}
export function sipRegister(data) {
  return axios({ url: '/sip/register', method: 'post', data: data });
}
export function sipFindPassword(data) {
  return axios({ url: '/sip/find/password', method: 'post', data: data });
}

// account
export function accountGet() {
  return axios({ url: '/account/get', method: 'get' });
}

export function accountUpdate(data) {
  return axios({ url: '/account/update', method: 'post', data: data });
}
export function accountRefundBalance(data) {
  return axios({ url: '/account/refund/balance', method: 'post', data: data });
}
export function accountCount() {
  return axios({ url: '/account/count', method: 'get' });
}
export function accountList(type, params) {
  return axios({ url: '/account/list/' + type, method: 'get', params: params });
}
export function accountInviterCheck(c) {
  return axios({ url: '/account/inviter/check/' + c, method: 'get' });
}
// account  withdraw
export function accountWithdraw(data) {
  return axios({ url: '/account/withdraw', method: 'post', data: data });
}
export function accountWithdrawPass(data) {
  return axios({ url: '/account/withdraw/pass', method: 'post', data: data });
}
export function accountWithdrawList(params) {
  return axios({
    url: '/account/withdraw/list',
    method: 'get',
    params: params
  });
}

// recharge
export function rechargePay(data) {
  return axios({ url: '/recharge/pay', method: 'post', data: data });
}
export function rechargeList(params) {
  return axios({ url: '/recharge/list', method: 'get', params: params });
}

// bill
export function billList(params) {
  return axios({ url: '/bill/list', method: 'get', params: params });
}
export function billAdminList(params) {
  return axios({ url: '/bill/list/admin', method: 'get', params: params });
}

// oem
export function oemGet(params) {
  return axios({ url: '/oem', method: 'get', params: params });
}
export function oemList(params) {
  return axios({ url: '/oem/list', method: 'get', params: params });
}
export function oemInsert(data) {
  return axios({ url: '/oem/insert', method: 'post', data: data });
}
export function oemUpdate(data) {
  return axios({ url: '/oem/update', method: 'post', data: data });
}
export function oemDelete(id) {
  return axios({ url: '/oem/delete', method: 'delete', data: [id] });
}
export function oemInviterList(params) {
  return axios({ url: '/oem/list/inviter', method: 'get', params: params });
}

export function oemInviterUpdate(data) {
  return axios({ url: '/oem/update/inviter', method: 'post', data: data });
}
// app
export function appGet() {
  return axios({ url: '/app/get', method: 'get' });
}
export function appReset() {
  return axios({ url: '/app/reset', method: 'get' });
}
export function appUpdate(data) {
  return axios({ url: '/app/update', method: 'post', data: data });
}
export function appCallback() {
  return axios({ url: '/app/callback', method: 'post' });
}

// address
export function addressGet() {
  return axios({ url: '/address', method: 'get' });
}
export function addressList(platform) {
  return axios({
    url: '/address/list',
    method: 'get',
    params: { platform: platform }
  });
}
export function addressUpdate(data) {
  return axios({ url: '/address/update', method: 'post', data: data });
}
// /address/logistics
export function addressLogisticsList(params) {
  return axios({
    url: '/address/logistics/list',
    method: 'get',
    params: params
  });
}
export function addressLogisticsListByUser(uid) {
  return axios({ url: '/address/logistics/list/' + uid, method: 'get' });
}
export function addressLogisticsUpdate(data) {
  return axios({
    url: '/address/logistics/update',
    method: 'post',
    data: data
  });
}
export function addressLogisticsInsert(data) {
  return axios({
    url: '/address/logistics/insert',
    method: 'post',
    data: data
  });
}
export function addressByUser(uid) {
  return axios({ url: '/address/' + uid, method: 'get' });
}

// /goods
export async function goodsList(params) {
  const res = await axios({
    url: "/goods/list",
    method: "get",
    params: params
  });
  if (res.code === 0) {
    res.data.list.forEach(val => {
      val.picture = replaceImage(val.picture);
    });
  }
  return res;
}
export async function goodsListAll(params) {
  const res = await axios({
    url: "/goods/list/all",
    method: "get",
    params: params
  });
  if (res.code === 0) {
    res.data.list.forEach(val => {
      val.picture = replaceImage(val.picture);
    });
  }
  return res;
}
export function goodsUpdate(data) {
  return axios({ url: '/goods/update', method: 'post', data: data });
}
export function goodsInsert(data) {
  return axios({ url: '/goods/insert', method: 'post', data: data });
}

// /goods/partition
export function goodsPartitionList(params) {
  return axios({ url: '/goods/partition/list', method: 'get', params: params });
}
export function goodsPartitionUpdate(data) {
  return axios({ url: '/goods/partition/update', method: 'post', data: data });
}
export function goodsPartitionInsert(data) {
  return axios({ url: '/goods/partition/insert', method: 'post', data: data });
}

// order
export function orderStatistics(params) {
  return axios({
    url: '/order/detail/select/sum',
    method: 'get',
    params: params
  });
}
export function orderGet(type, id) {
  return axios({ url: '/order/' + type + '/' + id, method: 'get' });
}
export async function orderList(params, type) {
  const res = await axios({
    url: "/order/list/" + type,
    method: "get",
    params: params
  });
  if (res.code === 0) {
    res.data.list.forEach(val => {
      if (val.goods) {
        val.goods.picture = replaceImage(val.goods.picture);
      }
    });
  }
  return res;
}
export function orderCount(params, type) {
  return axios({ url: '/order/count/' + type, method: 'get', params: params });
}
export function orderUpdate(data, type) {
  return axios({ url: '/order/update/' + type, method: 'post', data: data });
}
export function orderInsert(data) {
  return axios({ url: '/order/insert', method: 'post', data: data });
}
export function orderPay(data) {
  return axios({ url: '/order/pay', method: 'post', data: data });
}
export function orderCancel(id) {
  return axios({ url: '/order/cancel/' + id, method: 'delete' });
}
export function orderClose(type, id) {
  return axios({ url: '/order/close/' + type + '/' + id, method: 'delete' });
}
export function orderPlatformToId(id) {
  return axios({ url: '/order/platform/to/' + id, method: 'post' });
}
// order/detail
export function orderDetailClose(type, id) {
  return axios({
    url: '/order/detail/close/' + type + '/' + id,
    method: 'delete'
  });
}
export function orderDetailSend(data) {
  return axios({ url: '/order/detail/send', method: 'post', data: data });
}
export function orderDetailUpdate(data, type) {
  return axios({
    url: '/order/detail/update/' + type,
    method: 'post',
    data: data
  });
}
export function orderDetailList(params, type) {
  return axios({
    url: '/order/detail/list/' + type,
    method: 'get',
    params: params
  });
}
export function orderDetailSendMany(data) {
  return axios({
    url: '/order/detail/send/many',
    method: 'post',
    data: data,
    timeout: 100000
  });
}

// file
export function filePreUpload() {
  return axios({ url: '/file/pre/upload', method: 'get' });
}
// 上传到OSS
export function uploadOSS(url, formData) {
  return axios({
    url: url,
    method: 'post',
    processData: false,
    data: formData
  });
}

// store
export function storeList(params) {
  return axios({ url: '/shop/list', method: 'get', params: params });
}
export function storeOrders(id, params) {
  return axios({ url: '/shop/orders/' + id, method: 'get', params: params });
}
// export function storeInsert (data, token) { return axios({ url: '/shop/insert', method: 'post', headers: {'Authorization': token}, data: data }) }
export function storeDelete(id) {
  return axios({ url: '/shop/delete/' + id, method: 'delete' });
}
export function storeUpdate(type, data) {
  return axios({ url: '/shop/update/' + type, method: 'post', data: data });
}

// premium
export function premiumList(params) {
  return axios({ url: '/premium/list', method: 'get', params: params });
}
export function premiumUpdate(data) {
  return axios({ url: '/premium/update', method: 'post', data: data });
}
export function premiumInsert(data) {
  return axios({ url: '/premium/insert', method: 'post', data: data });
}
export function premiumDelete(id) {
  return axios({ url: '/premium/delete/' + id, method: 'delete' });
}
// agent/level
export function agentLevelAll(params) {
  return axios({ url: '/agent/level/all', method: 'get', params: params });
}

// agent/order
export function agentOrderGet(params) {
  return axios({ url: '/agent/order/get', method: 'get', params: params });
}
export function agentOrderPay(data) {
  return axios({ url: '/agent/order/pay', method: 'post', data: data });
}
export function agentAlipayCheck(data) {
  return axios({ url: '/alipay/check', method: 'post', data: data });
}
//淘宝文件解密
export function getExcelPassword(data) {
  return axios({ url: '/file/excel/password', method: 'post', data: data });
}

// 代发端下载
// type 1 普通用户  查询自己所有的子订单
//   2 返回自己出售的所有子订单
export function orderAllDetail(type, params) {
  return axios({
    url: '/order/detail/all/' + type,
    method: 'get',
    params: params
  });
}
// 地址解析接口
export function addressAnalysisReq(add) {
  return axios({ url: '/address/analysis', method: 'post', data: { add } });
}

/** 实名认证
 * @param data.certNo // 身份证
 * @param data.certName // 姓名
 * @param data.certPhone // 手机号
 */
export const certifyPersonInfo = async (data) => {
  return axios({
    method: 'post',
    url: '/certify/log/add',
    data
  })
}

/** 确认是不是扫脸验证成功
 * @param data.certNo // 身份证
 * @param data.certName // 姓名
 * @param data.certPhone // 手机号
 */
export const confrimFaceSuccess = async (data) => {
  return axios({
    method: 'post',
    url: '/certify/log/check',
    data
  })
}

/** 查看验证列表 */
export const queryVertifyList = async (params) => {
  return axios({
    url: '/certify/log/list',
    params
  })
}